var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"Price"},[_vm._v(" ¥ "),_c('s-o-simple-price',{attrs:{"prices":_vm.prices}}),_c('span',{staticClass:"Small"},[_vm._v(" ("+_vm._s(_vm.showLabel)),(_vm.isSotozei)?_c('span',{staticClass:"Price"},[_vm._v("¥"+_vm._s(_vm.showPrice))]):_vm._e(),_vm._v(")")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }